import { useNavigate } from "react-router-dom";

import {
  Site, DeviceData,
} from "../../model/model";

import SessionStore from "../../model/SessionStore";
import DeviceForm from "./DeviceForm";

interface IProps {
  site: Site;
  deviceData: DeviceData;
}

function EditDevice(props: IProps) {
  const navigate = useNavigate();

  const onFinish = (obj: DeviceData) => {
    SessionStore.getClient().updateDevice(obj, SessionStore.getBearer()).then( () => {
      navigate(`/site/${props.site.id}/device/${obj.id}`);
    });
  };

  return <DeviceForm initialValues={props.deviceData} onFinish={onFinish} site={props.site} update />;
}

export default EditDevice;
